import {Component, OnInit} from '@angular/core';
import {UserService} from '../user.service';
import {LayoutService} from '../../layout/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../smartadmin.config';
import { AppState } from '../../../app.service';
@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user: any = {
    "username": "Test Doe",
    "picture": "assets/img/avatars/sunny.png",
    "activity": 12
}

  constructor(
    private userService: UserService, private actr: ActivatedRoute, private router: Router,
     public layoutService: LayoutService, public appState: AppState) {
  }

  ngOnInit() {
    this.user.username = this.appState.get('username')
    const theme = this.appState.get('theme');
    this.layoutService.onSmartSkin(config.skins[theme]);
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts